// Verkennen (de graaf) per sector — pilot gereed 26-10, baan 1C.
//
// Verkennen draait alleen op een sector met onderwerpen en kaartcoördinaten;
// vandaag is dat ICT. /api/meta zegt op welke zichtbare sectoren hij draait
// (`verkennenSectoren` = proposities.yaml verkennen_sectoren ∩ zichtbaar).
// Staat ICT verborgen, dan is die lijst leeg: geen tabblad, en dus ook geen
// ICT-keuze die een 404 geeft.

import type { MetaResponse } from "../contracts";

/** De sectoren waarop Verkennen draait en die zichtbaar zijn. Zonder meta
 *  (nog aan het laden, of een storing): geen — beter even geen tabblad dan
 *  een tabblad dat op een verborgen sector opent. Een oudere dienst zonder
 *  het veld: ICT, als ICT zichtbaar is (het gedrag van vóór 1C). */
export function verkennenSectoren(meta: Pick<MetaResponse, "zichtbareSectoren" | "verkennenSectoren"> | null | undefined): string[] {
  if (!meta) return [];
  const zicht = meta.zichtbareSectoren?.length ? meta.zichtbareSectoren : ["ict"];
  return (meta.verkennenSectoren ?? ["ict"]).filter((s) => zicht.includes(s));
}

/** Hoort het tabblad Verkennen in de navigatie? */
export function magVerkennen(meta: Parameters<typeof verkennenSectoren>[0]): boolean {
  return verkennenSectoren(meta).length > 0;
}
